import { HttpGetCatalogService } from "./http-get-catalog.service";
import { Catalog, Dataset, Offer } from "../../models/catalog-dto";
import { datasetToAssetDTO } from "../../models/catalog";
import { Injectable } from "@angular/core";
import { Asset } from "../../models/asset";
import { map, Observable } from "rxjs";

type AssetWithOffers = Asset & { offers: Offer[] };

@Injectable({
  	providedIn: 'root'
})

export class GetCatalogService {

	constructor(
		private httpGetCatalogService: HttpGetCatalogService
	) { }

    public obtain$(): Observable<{ 
        assets: AssetWithOffers[];
    }> {

        return this.httpGetCatalogService.obtain$().pipe(

            map((catalogs: Catalog[]) => {

                const assets = catalogs.flatMap(catalog => {

                    const connectorID = catalog['dspace:participantId'] ?? '';
                    const originator = catalog['originator'] ?? '';

                    const datasets = Array.isArray(catalog['dcat:dataset'])
                        ? catalog['dcat:dataset']
                        : [catalog['dcat:dataset'] as Dataset];

                    return datasets.map((dataset: Dataset) => {

                        const dto = datasetToAssetDTO(dataset, catalog);

                        const offers = dto.offers;

                        const asset = Asset.createFromDTO(dto);

                        asset.connector = connectorID;
                        asset.originator = originator;

                        return {
                            ...asset,
                            offers
                        };

                    });

                });

                return { assets };

            })

        );
        
    }
    
}